import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import BasicLayout from "../../layauots/BasicLayout";
import { Card, Alert, AlertTitle } from "@mui/material";
import MDBox from "../../controls/MDBox";
import MDTypography from "../../controls/MDTypography";
import MDInput from "../../controls/MDInput";
import MDButton from "../../controls/MDButton";
import { Save } from "react-bootstrap-icons";
import { ExitToApp } from "@mui/icons-material";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import { MARCADORES_MENSAJE } from "../../Utils/Mensaje";

// Formulario compartido por MensajeAdd y MensajeEdit.
// onGuardar recibe { tipoMensaje, texto } y devuelve la respuesta de la API.
const MensajeForm = ({ titulo, descripcion, valoresIniciales, onGuardar, mensajeExito }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState(valoresIniciales);
  const [mensaje, setMensaje] = useState("");
  const [exito, setExito] = useState(false);
  const [grabando, setGrabando] = useState(false);
  const [nombreboton, setnombreboton] = useState("Cancelar");

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleVolver = () => navigate("/MensajeList");

  const handleSubmit = async () => {
    if (!formData.tipoMensaje.trim() || !formData.texto.trim()) {
      setMensaje("Los campos Tipo Mensaje y Mensaje son obligatorios");
      setExito(false);
      return;
    }
    try {
      setGrabando(true);
      setMensaje("");
      const res = await onGuardar({
        tipoMensaje: formData.tipoMensaje.trim(),
        texto: formData.texto.trim(),
      });
      if (res?.isSuccess) {
        setMensaje(mensajeExito);
        setExito(true);
        setnombreboton("Volver");
      } else {
        setMensaje(res?.error || "Error al guardar");
        setExito(false);
        setGrabando(false);
      }
    } catch (error) {
      setMensaje(error?.detail || error?.message || "Error en la solicitud");
      setExito(false);
      setGrabando(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card style={{ width: "157%" }}>
        <MDBox
          variant="gradient"
          bgColor="secondary"
          borderRadius="lg"
          coloredShadow="light"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {titulo}
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            {descripcion}
          </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                name="tipoMensaje"
                label="Tipo Mensaje"
                variant="standard"
                value={formData.tipoMensaje}
                onChange={handleInputChange}
                inputProps={{ maxLength: 100 }}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="text"
                name="texto"
                label="Mensaje"
                variant="standard"
                value={formData.texto}
                onChange={handleInputChange}
                inputProps={{ maxLength: 2000 }}
                multiline
                rows={5}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="caption" color="text" display="block">
                Marcadores disponibles (se reemplazan al enviar el mensaje):
              </MDTypography>
              {MARCADORES_MENSAJE.map((m) => (
                <MDTypography key={m.marcador} variant="caption" color="text" display="block">
                  <strong>{m.marcador}</strong> — {m.descripcion}
                </MDTypography>
              ))}
            </MDBox>
            <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
              <MDButton
                onClick={handleSubmit}
                variant="gradient"
                color="success"
                endIcon={<Save />}
                disabled={grabando}
                fullWidth
              >
                Grabar
              </MDButton>
              <MDButton
                onClick={handleVolver}
                variant="gradient"
                color="error"
                endIcon={<ExitToApp />}
                fullWidth
              >
                {nombreboton}
              </MDButton>
            </MDBox>
          </MDBox>

          {mensaje && (
            <Alert severity={exito ? "success" : "error"}>
              <AlertTitle>{exito ? "Felicitaciones" : "Error"}</AlertTitle>
              {mensaje}
            </Alert>
          )}
        </MDBox>
      </Card>
    </BasicLayout>
  );
};

export default MensajeForm;
